import {createStyles, makeStyles, Theme} from '@material-ui/core';
import { PRIMARY_RED } from '../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuLink: {
            textDecoration: 'none',
        },
        menuActiveLink: {
            color: theme.palette.secondary.main,
            textDecoration: 'underline',
        },
        menuButton: {
            color: 'inherit',
        },
    }),
);

export default useStyles;
